export default {"src":"/_next/static/media/NZ.fe2b6d73.svg","height":20,"width":30};